import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type AnalyticsDataStream from "./AnalyticsDataStream";
import type Organisation from "./Organisation";

@Model()
class AnalyticsIntegration extends ApplicationRecord {
  static jsonapiType = "analytics_integrations";

  @HasMany() analyticsDataStreams: AnalyticsDataStream[];

  @Attr() analyticsProperty: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() isIntegrated: boolean;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() serviceAccount: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default AnalyticsIntegration;
